import { createGlobalStyle } from 'styled-components'
import { Classes, Colors } from '@blueprintjs/core'

export const SpecialClasses = {
  TimeRangePickerPopover: 'time-range-picker-popover',
}

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    background-color: ${({ theme: { darkMode } }) =>
      darkMode ? Colors.DARK_GRAY3 : Colors.LIGHT_GRAY5};
    -webkit-font-smoothing: antialiased
  }
  .${SpecialClasses.TimeRangePickerPopover} > .${
  Classes.POPOVER_CONTENT
} > div > .${Classes.MENU} {
    max-width: fit-content;
  }
`
export default GlobalStyle
